module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-footer.c697e3c9.png";